<template>
  <div>
    <div class="general-panel">
      <div class="general-panel__heading"><strong>{{ $t('HEADING_SAMPLE_TOKENS') }}</strong> <i class="fa fa-question-circle m-l-5" aria-hidden="true" /></div>
      <div class="general-panel__content form-horizontal">
          <div
            v-for="(macro, index) in selectedMacros"
            :key="index"
          >
            <ValidationProvider
              v-slot="{ classes }"
              :ref="`sampleToken${index}`"
              rules="required"
              slim
            >
              <div :class="classes">
                <label class="p-t-7">{{ macro.name }}</label>
                <i class="fa fa-long-arrow-right m-l-5 m-r-5" aria-hidden="true" />
                <input
                  v-model="macro.value"
                  :href="`sampleToken${index}`"
                  type="text"
                  class="form-control width-auto"
                />
                <label 
                  v-t="'REQUIRED'"
                  class="form-group__label-required m-l-15"
                />
              </div>
            </ValidationProvider>
          </div>
      </div>
    </div>
  </div> 
</template>

<script>
import sharedMessages from '@/core/locales';

export default {
  name: 'HttpRequestSampleTokens',
  props: {
    selectedMacros: {
      type: Array,
      default() {
        return [];
      },
    },
  },

  i18n: {
    sharedMessages,
    locale: 'en'
  } 
};
</script>